import { ColumnDef } from '@tanstack/react-table';

import { TStockAdjustmentListItem } from '@/features/slice/inventory';

export const stockAdjustmentListColumns: Array<
    ColumnDef<TStockAdjustmentListItem>
> = [
    {
        accessorKey: 'product_name',
        header: () => <div>Product Name</div>,
        cell: ({ row }) => <div>{row.original.product_name}</div>,
    },

    {
        accessorKey: 'created_at',
        header: () => <div>Time</div>,
        cell: ({ row }) => (
            <div>{new Date(row.original.created_at).toLocaleDateString()}</div>
        ),
    },

    {
        accessorKey: 'quantity',
        header: () => <div className={'text-right'}>Quantity</div>,
        cell: ({ row }) => (
            <div className={'text-right'}>{row.original.quantity}</div>
        ),
    },
    {
        accessorKey: 'brand_name',
        header: () => <div>Brand</div>,
        cell: ({ row }) => <div>{row.original.brand_name}</div>,
    },
    {
        accessorKey: 'note',
        header: () => <div>Note</div>,
        cell: ({ row }) => <div>{row.original.note}</div>,
    },
    // {
    //     accessorKey: '',
    //     header: () => <div>Product Name</div>,
    //     cell: ({ row }) => <div>{row.original.product_name}</div>,
    // },
];
